import Header from './Header';
import Footer from './Footer';
import { useNavigate } from 'react-router-dom';


function Home(lang) {
  const navigate = useNavigate();
  const handleRedirect = (direction)=>{
    let navigatewindow = window.location.pathname.substring(0,3);
    if(navigatewindow==="/"){
      navigatewindow+="pl";
      
    }
    if(navigatewindow!=="/ua"&&direction===" "){
      navigatewindow="";
      console.log(navigatewindow);
      
    }
    
    navigate(navigatewindow+"/" + direction);
  }
  if(lang.lang==="pl"){
    return (
      <div className="App">
        <Header/>
        <div className='upperbody'>
          <div className='upperblock' id='upperblock1'>
            <br />
            <h1>Twój partner w biznesowym sukcesie</h1>
            <br />
            <h3>Witamy w "TELETEL" – Twoim zaufanym partnerze w księgowości i doradztwie biznesowym. Oferujemy kompleksowe usługi, które wspierają przedsiębiorców oraz obcokrajowców w realizacji marzeń biznesowych w Polsce.</h3>
            <br />
            <h3>Razem osiągniemy sukces!</h3>
            <br />
            <button onClick={()=>handleRedirect('contact')}>KONTAKT</button>
          </div>
          <div className='upperblock' id='upperblock2'>
            <img src='/splash.jpg' alt='co-working' />
          </div>
  
        </div>
        <div className='midbody'>
          <div className='midblock' id='midblock1'>
            <h1>Poznaj nas lepiej</h1>
            <br />
            <h3>Nasza firma "TELETEL BiznesPlus" powstała z pasji do wspierania przedsiębiorców oraz obcokrajowców realizujących swoje marzenia w Polsce. Od 2015 roku oferujemy kompleksowe usługi księgowe, doradztwo biznesowe, pomoc w legalizacji działalności oraz wsparcie w uzyskaniu zezwoleń na pobyt czasowy, stały oraz obywatelstwa. Zespół wykwalifikowanych specjalistów z doświadczeniem w różnych dziedzinach dostosowuje ofertę do indywidualnych potrzeb klientów. Stawiamy na profesjonalizm, rzetelność oraz zaangażowanie, aby wspierać naszych klientów na każdym etapie ich działalności. Zachęcamy do odwiedzenia naszej strony internetowej, aby zapoznać się z pełną ofertą i skorzystać z naszych usług online. "TELETEL BiznesPlus" to Twój partner w drodze do sukcesu!</h3>
          </div>
          <div className='midblock' id='midblock2'>
            <img src='/midsplash.webp' alt='co-working' />
            <div className='overimg' id='overimg1'><br /><h2>+20</h2><h5>Specjaliści</h5></div>
            <div className='overimg' id='overimg2'><br /><h2>+15</h2><h5>Zrealizowane projekty</h5></div>
            <div className='overimg' id='overimg3'><br /><h2>+227</h2><h5>Zadowoleni klienci</h5></div>
          </div>
        </div>
        <div className='pricesbody'>
          <div id='pricestext'>
            <h3>CENNIK</h3>
            <h1>Plany</h1>
            <br />
          </div>
          <div id='pricesgrid'>
            <div className='prices'>
              <img alt='pricesimg' src='/price1.webp' />
              <br />
              <h3>Usługi Księgowe - pełna obsługa księgowa</h3>
              <h1>od 650 PLN</h1>
              <br />
              <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Rzetelne prowadzenie ksiąg rachunkowych</h5></h2>
              <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Przygotowanie deklaracji podatkowych</h5></h2>
  
            </div>
            <div className='prices'>
              <img alt='pricesimg' src='/price2.webp' />
              <br />
              <h3>Usługi księgowe - działalność gospodarcza</h3>
              <h1>od 250 PLN</h1>
              <br />
              <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>KRiP, Księga przychodów ,ogólne zasady, ryczałt, podatek linowy</h5></h2>
              <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Przygotowanie deklaracyj podatkowych</h5></h2>
            </div>
            <div className='prices'>
              <img alt='pricesimg' src='/price3.webp' />
              <br />
              <h3>Legalizacja Biznesu i Pobytu dla obcokrajowców</h3>
              <h1>od 600 PLN</h1>
              <br />
              <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Rejestracja działalności gospodarczej</h5></h2>
              <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Uzyskanie zezwolenia na pobyt i pracę</h5></h2>
            </div>
            <br />
          </div>
  
        </div>
        <div className='serviceblock'>
          <br />
          <div id='servicetext'>
            <h3>OFERTA</h3>
            <h1>Nasze usługi</h1>
          </div>
          <div id='servicegrid'>
            <div className='service' id='service1'>
              <div className='servicegridtext'>
                <h2>Usługi księgowe</h2>
                <h4>Zapewniamy pełną obsługę księgową, prowadzenie ksiąg rachunkowych, przygotowanie deklaracji podatkowych, komunikacja z urzędami, przygotowanie sprawozdań</h4>
              </div>
              <div className='servicegridtext'>
                <h2>Doradztwo biznesowe</h2>
                <h4>Pomagamy w opracowywaniu strategii rozwoju, analizy rynku oraz pozyskiwaniu funduszy na rozwój.</h4>
              </div>
              <div className='servicegridtext'>
                <h2>Legalizacja biznesu</h2>
                <h4>Wspieramy w zakupie, rejestracji oraz legalizacji działalności gospodarczej w Polsce, zapewniając kompleksową obsługę.</h4>
              </div>
            </div>
            <div className='service'>
              <img src='/service.webp' alt='placeholder' />
            </div>
            <div className='service' id='service2'>
              <div className='servicegridtext'>
                <h2>Usługi legalizacji</h2>
                <h4>Oferujemy pomoc w uzyskaniu zezwoleń na pobyt dla obcokrajowców planujących osiedlenie się w Polsce.</h4>
              </div>
              <div className='servicegridtext'>
                <h2>Optymalizacja podatkowa</h2>
                <h4>Nasz zespół specjalistów pomaga w identyfikacji możliwości redukcji obciążeń podatkowych przedsiębiorstw.</h4>
              </div>
              <div className='servicegridtext'>
                <h2>Szkolenia przedsiębiorców</h2>
                <h4>Organizujemy szkolenia i warsztaty dotyczące zarządzania finansami, marketingu oraz przepisów prawnych.</h4>
              </div>
            </div>
          </div>
          <button onClick={()=>handleRedirect('ofert')}>ZOBACZ WIĘCEJ</button>
        </div>
        <br/>
        <Footer/>
      </div>
    );
  }
  if(lang.lang==="ua"){
    return (
      <div className="App">
        <Header/>
        <div className='upperbody'>
          <div className='upperblock' id='upperblock1'>
            <br />
            <h1>Твій партнер у бізнесі</h1>
            <br />
            <h3>Ласкаво просимо до «TELETEL» – вашого надійного партнера з бухгалтерського обліку та бізнес-консалтингу. Ми надаємо комплексні послуги, спрямовані на підтримку підприємців і громадян інших країн у втіленні їхніх бізнес-мрій у Польщі.</h3>
            <br />
            <h3>Разом ми зможемо досягти великих успіхів!</h3>
            <br />
            <button onClick={()=>handleRedirect('contact')}>КОНТАКТ</button>
          </div>
          <div className='upperblock' id='upperblock2'>
            <img src='/splash.jpg' alt='co-working' />
          </div>
  
        </div>
        <div className='midbody'>
          <div className='midblock' id='midblock1'>
            <h1>ПОЗНАЙОМСЯ З НАМИ БЛИЖЧЕ </h1>
            <br />
            <h3>Наша компанія «TELETEL» створена з пристрастю до підтримки підприємців і громадян інших країн, які здійснюють свої мрії в Польщі. З 2015 року ми пропонуємо комплексні бухгалтерські послуги, бізнес-консалтинг, допомогу в легалізації діяльності, а також підтримку в отриманні дозволів на тимчасове та постійне проживання, а також громадянства. Команда кваліфікованих спеціалістів із досвідом у різних галузях адаптує наші послуги до індивідуальних потреб клієнтів. Ми робимо ставку на професіоналізм, надійність і відданість справі, щоб підтримувати наших клієнтів на кожному етапі їхнього бізнесу. Запрошуємо відвідати наш вебсайт, щоб ознайомитися з повним спектром послуг і скористатися нашими онлайн-сервісами. «TELETEL» – ваш партнер на шляху до успіху!</h3>
          </div>
          <div className='midblock' id='midblock2'>
            <img src='/midsplash.webp' alt='co-working' />
            <div className='overimg' id='overimg1'><br /><h2>+20</h2><h5>СПЕЦІАЛІСТИ</h5></div>
            <div className='overimg' id='overimg2'><br /><h2>+15</h2><h5>ЗРЕАЛІЗОВАНІ ПРОЕКТИ</h5></div>
            <div className='overimg' id='overimg3'><br /><h2>+227</h2><h5>ЗАДОВОЛЕНІ КЛІЄНТИ</h5></div>
          </div>
        </div>
        <div className='pricesbody'>
          <div id='pricestext'>
            <br/>
            <h1>НАШІ ЦІНИ</h1>
            <br />
          </div>
          <div id='pricesgrid'>
            <div className='prices'>
              <img alt='pricesimg' src='/price1.webp' />
              <br />
              <h3>Бухгалтерські послуги - повне бухгалтерське обслуговування</h3>
              <h1>від 650 PLN</h1>
              <br />
              <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Надійне ведення бухгалтерського обліку</h5></h2>
              <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Підготовка податкових декларацій</h5></h2>
  
            </div>
            <div className='prices'>
              <img alt='pricesimg' src='/price2.webp' />
              <br />
              <h3>Бухгалтерські послуги - підприємницька діяльність</h3>
              <h1>від 250 PLN</h1>
              <br />
              <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>ведення бухгалтерії для різних видів оподаткування</h5></h2>
              <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}> Підготовка податкової звітності</h5></h2>
            </div>
            <div className='prices'>
              <img alt='pricesimg' src='/price3.webp' />
              <br />
              <h3>Легалізація бізнесу та перебування в Польщі</h3>
              <h1>від 300 PLN</h1>
              <br />
              <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>Реєстрація  всіх видів бізнесу</h5></h2>
              <h2 id='checkmark'>&#x2713;<h5 style={{ marginTop: "-25px" }}>легалізація перебування, отримання дозволів на працю</h5></h2>
            </div>
            <br />
          </div>
  
        </div>
        <div className='serviceblock'>
          <br />
          <div id='servicetext'>
            <br/>
            <h1>НАШІ ПОСЛУГТИ</h1>
          </div>
          <div id='servicegrid'>
            <div className='service' id='service1'>
              <div className='servicegridtext'>
                <h2>БУХГАЛТЕРСЬКІ ПОСЛУГИ</h2>
                <h4>Надаємо повний бухгалтерський облік для різних видів підприємницької діяльності, податкові декларації, спілкування з адміністративними органими в тим подадтковю, підготовка різних видів звітності</h4>
              </div>
              <div className='servicegridtext'>
                <h2>БІЗНЕС КОНСАЛТІНГ</h2>
                <h4>Допомагаємо у розробці стратегії розвитку, аналізі ринку та залученні коштів для розвитку.</h4>
              </div>
              <div className='servicegridtext'>
                <h2>ЛЕГАЛІЗАЦІЯ БІЗНЕСУ</h2>
                <h4>Допомагаємо з купівлею, реєстрацією та легалізацією бізнесу в Польщі, надаючи Комплексне обслуговування.</h4>
              </div>
            </div>
            <div className='service'>
              <img src='/service.webp' alt='placeholder' />
            </div>
            <div className='service' id='service2'>
              <div className='servicegridtext'>
                <h2>ЛЕГАЛІЗАЦІЯ ПРОЖИВАННЯ</h2>
                <h4>Допомагаємо в отриманні дозволу на проживання для іноземців, які планують оселитися в Польщі</h4>
              </div>
              <div className='servicegridtext'>
                <h2>ПОДАТКОВА ОПТИМІЗАЦІЯ</h2>
                <h4>Наша команда фахівців допомагає виявити можливості зниження податкового тягаря підприємств.</h4>
              </div>
              <div className='servicegridtext'>
                <h2>НАВЧАННЯ ПІДПРИЄМЦІВ</h2>
                <h4>Організовуємо тренінги та семінари з фінансового менеджменту, маркетингу та законодавства.</h4>
              </div>
            </div>
          </div>
          <button onClick={()=>handleRedirect('ofert')}>ПЕРЕГЛЯНУТИ БІЛЬШЕ</button>
        </div>
        <br/>
        <Footer/>
      </div>
    );
  }
  
}

export default Home;
